import { render, staticRenderFns } from "./ClassMarkDataTable.vue?vue&type=template&id=0796085c&scoped=true&"
import script from "./ClassMarkDataTable.vue?vue&type=script&lang=js&"
export * from "./ClassMarkDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ClassMarkDataTable.vue?vue&type=style&index=0&id=0796085c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0796085c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
